import React, { useMemo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Select } from 'antd';
import DisplayText from '../common/text/DisplayText';

const { Option } = Select;

const getRateTitle = ({ name, rate } = {}) => {
  if (!name) return null;
  if (rate !== null) return `${name} - $${rate.toFixed(2)}`;
  return name;
};

export default function BillingRateSelector({
  billingRateId,
  isNotDisplay,
  onChange,
  onlyNames,
  displayStyle = {},
  style = {},
  customEntries = [],
}) {
  const billingRates = useSelector((s) => s.billingRates);
  const preset = useMemo(() => Object.values(billingRates), [billingRates]);
  const [custom, setCustom] = useState(null);

  const list = useMemo(() => {
    const m = new Map();
    [...preset, ...customEntries, ...(custom ? [custom] : [])].forEach((r) => m.set(r.id, r));
    return [...m.values()];
  }, [preset, customEntries, custom]);

  const handleChange = useCallback((val) => {
    if (val && !list.some((r) => r.id === val)) {
      setCustom({
        id: val,
        name: val,
        rate: null,
        isCustom: true,
      });
    }
    onChange(val ?? null);
  }, [onChange, list]);

  const filterOption = useCallback(
    (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    [],
  );

  const handleSearch = useCallback((input) => {
    if (!input) {
      setCustom(null);
      return;
    }
    if (!list.some((r) => r.name?.toLowerCase() === input.toLowerCase())) {
      setCustom({
        id: input,
        name: input,
        rate: null,
        isCustom: true,
      });
    } else {
      setCustom(null);
    }
  }, [list]);
  if (!isNotDisplay) {
    const picked = list.find((r) => r.id === billingRateId);
    return <DisplayText title={getRateTitle(picked)} style={displayStyle} />;
  }

  return (
    <Select
      value={billingRateId}
      allowClear
      showSearch
      filterOption={filterOption}
      onSearch={handleSearch}
      onChange={handleChange}
      placeholder="Select a billing rate"
      style={style}
    >
      {list
        .filter((r) => r.name?.trim())
        .map(({ id, name, rate }) => {
          const title = onlyNames ? name : getRateTitle({ name, rate });
          return (
            <Option key={id} value={id} title={title}>
              {title}
            </Option>
          );
        })}
    </Select>
  );
}
